import { render, staticRenderFns } from "./PerubahanProfil.vue?vue&type=template&id=463ce3aa"
import script from "./PerubahanProfil.vue?vue&type=script&lang=js"
export * from "./PerubahanProfil.vue?vue&type=script&lang=js"
import style0 from "./PerubahanProfil.vue?vue&type=style&index=0&id=463ce3aa&prod&lang=scss"
import style1 from "./PerubahanProfil.vue?vue&type=style&index=1&id=463ce3aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports